import type { FileResult } from "../types";

function bucket(result: FileResult): number {
  if (result.status !== "done") return 1;
  if (result.tag === "pending_review") return 0;

  return 2;
}

export function sortResultsForCarousel(results: FileResult[]): FileResult[] {
  return [...results].sort((a, b) => {
    const aBucket = bucket(a);
    const bBucket = bucket(b);

    if (aBucket !== bBucket) return aBucket - bBucket;
    if (aBucket === 0) return a.score - b.score;

    return 0;
  });
}

function isActionable(result: FileResult): boolean {
  return result.status === "done" && result.tag === "pending_review";
}

export function findNextNeedsAttentionId(
  results: FileResult[],
  afterIndex: number,
): null | string {
  const forward = results
    .slice(afterIndex + 1)
    .find((result) => isActionable(result));

  if (forward) return forward.id;

  const wrapped = results
    .slice(0, afterIndex)
    .find((result) => isActionable(result));

  return wrapped?.id ?? null;
}
